import contentBlockEventListeners from './contentblockeventlisteners';
import fetchBuyItAgainData from './fetchbuyitagaindata';

const home = {
    setupBuyItAgain: function () {
        const minimumAmountOfProductsRequired = 4;

        fetchBuyItAgainData().then(data => {
            if (data && data.products && data.products.length > minimumAmountOfProductsRequired) {
                import('./buyitagain.js').then(({default: buyItAgain}) => buyItAgain.init(data));
            }
        });
    },
    setupCategories: function () {
        import('./categories.js').then(({default: categoriesSlider}) => categoriesSlider.init());
    },
    setupContentEventListeners: () => contentBlockEventListeners(),
    init: function () {
        this.setupBuyItAgain();
        this.setupCategories();

        if (window.videoHero) {
            import('./videohero.js').then(({ default: videoHero }) => videoHero(document.querySelector('.hero .image'), window.videoHero));
        }

        this.setupContentEventListeners();
    }
};


export default home;
